import logo from './logo/logo.png'
import logoWhite from './logo/logoWhite.png'
import facebook from './logo/facebook.svg'
import instagram from './logo/instagram.svg'
import whatsapp from './logo/whatsapp.svg'
import facebookAlt from './logo/facebook.png'
import instagramAlt from './logo/instagram.png'

import back from './illus/back.png'
import back1 from './illus/back2.png'
import back2 from './illus/back3.png'
import back3 from './illus/back4.png'
import quotes from './illus/quotes.svg'
import Location from './illus/location.png'
import Locations from './illus/locations.png'
import Login from './illus/login.png'
import SignUp from './illus/signUp.png'
import Card from './illus/card.png'

import noImage from './placeholders/noImage.png'
import Profile from './placeholders/profile.png'

import Hospitality from './categories/Hospitality.png'
import Healthcare from './categories/Healthcare.png'
import Retail from './categories/Retail.png'
import TravelTransport from './categories/Travel &  Transport.png'
import Education from './categories/Education.png'
import EventManagement from './categories/Event  Management.png'
import BankingFinance from './categories/Banking &  Finance.png'
import MediaTechnology from './categories/Media &  Technology.png'
import ConsumerGoodsDistribution from './categories/Consumer Goods & Distribution.png'
import EnergyRecourcesUtilities from './categories/Energy Recources  & Utilities.png'
import Insurance from './categories/Insurance.png'
import Manufacturing from './categories/Manufacturing.png'
import Legal from './categories/Legal.png'
import MarketingAdvertisment from './categories/Marketing  & Advetisment.png'
import Infrastructure from './categories/Infrastructure.png'
import International from './categories/International.png'
import Agricultural from './categories/Agricultural.png'
import Ecommerce from './categories/Ecommerce.png'
import Sports from './categories/Sports.png'
import Textile from './categories/Textile.png'
import Research from './categories/Research.png'
import Culture from './categories/Culture.png'
import Publication from './categories/Publication.png'
import Innovation from './categories/Innovation.png'

import Hotels from './subCategories/Hotels.png'
import Restaurants from './subCategories/Restaurants.png'
import Resorts from './subCategories/Resorts.png'
import Marriage from './subCategories/Marriage.png'
import SportsTrending from './subCategories/Sports.png'
import Corporate from './subCategories/Corporate.png'
import Grocery from './subCategories/Grocery.png'
import SpareParts from './subCategories/SpareParts.png'
import Supermarkets from './subCategories/Supermarkets.png'
import SchoolCollege from './subCategories/SchoolCollege.png'
import CoachingInstitutes from './subCategories/CoachingInstitutes.png'
import SkillDevelopment from './subCategories/Skill development.png'

const main = {
  logo,
  logoWhite,
  facebook,
  instagram,
  whatsapp,
  facebookAlt,
  instagramAlt,
  back,
  back1,
  back2,
  back3,
  quotes,
  Location,
  Locations,
  Login,
  SignUp,
  Card,
  noImage,
  Profile,
  Hospitality,
  Healthcare,
  Retail,
  TravelTransport,
  Education,
  EventManagement,
  BankingFinance,
  MediaTechnology,
  ConsumerGoodsDistribution,
  EnergyRecourcesUtilities,
  Insurance,
  Manufacturing,
  Legal,
  MarketingAdvertisment,
  Infrastructure,
  International,
  Agricultural,
  Ecommerce,
  Sports,
  Textile,
  Research,
  Culture,
  Publication,
  Innovation,
  Hotels,
  Restaurants,
  Resorts,
  Marriage,
  SportsTrending,
  Corporate,
  Grocery,
  SpareParts,
  Supermarkets,
  SchoolCollege,
  CoachingInstitutes,
  SkillDevelopment
}

export default main
